module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-footer footer-wrapper"
  }, [_c('div', {
    staticClass: "lang-wrapper"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.changeLocale('zh-CN')
      }
    }
  }, [_vm._v("简体")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.changeLocale('zh-TW')
      }
    }
  }, [_vm._v("繁體")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.changeLocale('en')
      }
    }
  }, [_vm._v("English")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.changeLocale('ru_RU')
      }
    }
  }, [_vm._v("Pусский")])])])]), _vm._v(" "), _c('div', {
    staticClass: "copy-right"
  }, [_c('span', [_vm._v("Copyright © " + _vm._s(_vm.year) + " CZUR Technology Co.,Ltd. All rights reserved. "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("辽ICP备13011158号-8")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0de41ea6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0de41ea6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer.vue
// module id = 28
// module chunks = 1 2 3 4 5 6 7